import React from "react";
import styled from "styled-components";
import { withPrefix } from "gatsby";
import dataFlags from "../../data/bait-to-plate/data-flags-combined.json";
import FlagLegendItem, { StyledFlagLegendItem } from "./FlagLegendItemAlt";


const hasUyghurLaborFlag = (flags) => {
  return flags?.includes("uyghur-labor");
}
const hasNorthKoreanLaborFlag = (flags) => {
  return flags?.includes("north-korean-labor");
}

const hasEnvironmentalFlag = (flags) => {
  const environmentalFlagsSlugs = dataFlags.filter(flag => flag.is_environmental_concern).map((flag, index) => flag.slug);
  return flags?.filter(flag => environmentalFlagsSlugs.includes(flag))?.length > 0;
}
const hasHumanRightsFlag = (flags) => {
  const humanRightsFlagsSlugs = dataFlags.filter(flag => flag.is_human_rights_concern).map((flag, index) => flag.slug);
  return flags?.filter(flag => humanRightsFlagsSlugs.includes(flag))?.length > 0;
}

const BaitToPlateIndexItemFlags = ({ item, isSmall = false, asSummary = false, vesselSummaryOverride = false }) => {

  return (
    <StyledBaitToPlateIndexItemFlags className={isSmall ? "is-small" : undefined}>
      {! vesselSummaryOverride && item?.flags?.map((flag, index) => (
        <FlagLegendItem as="li" key={index} flagSlug={flag} />
      ))}
      {vesselSummaryOverride && item.type === 'vessel' && (
        <>
          {hasHumanRightsFlag(item?.flags) && (
            <StyledFlagLegendItem as="li" className="is-human-rights">
              <span>Human Rights & Labor</span>
            </StyledFlagLegendItem>
          )}
          {hasEnvironmentalFlag(item?.flags) && (
            <StyledFlagLegendItem as="li" className="is-environmental">
              <span>Fishing & Environmental</span>
            </StyledFlagLegendItem>
          )}
        </>
      )}
      {(item.type === "importer" || item.type === "buyer" || item.processor_flags ) && (
        <>
          {hasUyghurLaborFlag(item?.processor_flags) && (
            <StyledFlagLegendItem as="li" className="is-uyghur-labor">
              <span>{! item?.direct_labor_link && "* "}Uyghur Labor</span>
            </StyledFlagLegendItem>
          )}
          {hasNorthKoreanLaborFlag(item?.processor_flags) && (
            <StyledFlagLegendItem as="li" className="is-north-korean-labor">
              <span>{! item?.direct_labor_link && "* "}North Korean Labor</span>
            </StyledFlagLegendItem>
          )}
          {item?.processor_flags?.includes("human-rights") && (
            <StyledFlagLegendItem as="li" className="is-human-rights">
              <span>* Human Rights & Labor</span>
            </StyledFlagLegendItem>
          )}
          {item?.processor_flags?.includes("environmental") && (
            <StyledFlagLegendItem as="li" className="is-environmental">
              <span>* Fishing & Environmental</span>
            </StyledFlagLegendItem>
          )}
        </>
      )}
      {item.type !== "vessel" && (
        <>
          {asSummary ? (
            <>
              {hasHumanRightsFlag(item?.vessel_flags) && (
                <StyledFlagLegendItem as="li" className="is-human-rights">
                  <span>* Human Rights & Labor</span>
                </StyledFlagLegendItem>
              )}
              {hasEnvironmentalFlag(item?.vessel_flags) && (
                <StyledFlagLegendItem as="li" className="is-environmental">
                  <span>* Fishing & Environmental</span>
                </StyledFlagLegendItem>
              )}
            </>
          ) : (
            <>
              {item?.vessel_flags?.map((flag, index) => (
                <FlagLegendItem as="li" key={index} flagSlug={flag} linked={true} />
              ))}
            </>
          )}
        </>
      )}
    </StyledBaitToPlateIndexItemFlags>
  )
}

export default BaitToPlateIndexItemFlags;

export { StyledBaitToPlateIndexItemFlags };


const StyledBaitToPlateIndexItemFlags = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.375em;
  &.is-small {
    font-size: 0.9375em;
  }
`;